import React from "react";
import PropTypes from "prop-types";
import InputWrapper from "../InputWrapper";
import style from "../../../assets/css/styles.module.scss";
import useDeprecated from "../../../hooks/useDeprecated";

const DepInput = ({
  defaultValue,
  errorMsg,
  placeholder,
  type,
  className,
  value,
  options,
  isValid,
  onChange,
  id,
  name,
  label,
  afterInputText
}) => {
  const uncontrolledOptions = defaultValue ? { defaultValue } : {};
  const controlledOptions = value != null ? { value, onChange } : {};

  useDeprecated("DepInput", "Input");

  return (
    <InputWrapper
      className={className}
      isValid={isValid}
      errorMsg={errorMsg}
      label={label}
      afterInputText={afterInputText}
    >
      <input
        id={id}
        name={name}
        type={type}
        placeholder={placeholder}
        {...controlledOptions}
        {...uncontrolledOptions}
        className={isValid === false ? style.inputError : ""}
        {...options}
      />
    </InputWrapper>
  );
};

DepInput.displayName = "DepInput";

DepInput.defaultProps = {
  id: "",
  name: "",
  defaultValue: null,
  errorMsg: null,
  onChange: () => {},
  placeholder: null,
  className: null,
  type: "text",
  value: null,
  options: null,
  isValid: null,
  label: null,
  afterInputText: null
};

DepInput.propTypes = {
  /** Input id */
  id: PropTypes.string,
  /** Input name */
  name: PropTypes.string,
  /** Add any html attributes to the component */
  options: PropTypes.object,
  /** Change event callback */
  onChange: PropTypes.func,
  /** Input type */
  type: PropTypes.string,
  /** Input value */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Input default value */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Input validation error message */
  errorMsg: PropTypes.string,
  /** Input placeHolder */
  placeholder: PropTypes.string,
  /** Add className to the component */
  className: PropTypes.string,
  /** Is input valid */
  isValid: PropTypes.bool,
  /** If provided, will add label before the input */
  label: PropTypes.string,
  /** If provided, will add text after the input */
  afterInputText: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default DepInput;
